// extracted by mini-css-extract-plugin
export default {"card":"favProduct_card__t9Q3o","product":"favProduct_product__8jcap","price":"favProduct_price__rDVtw","remove":"favProduct_remove__UtuBO","add":"favProduct_add__TYOga"};